import React, { createContext, useContext, useEffect, useMemo, useState } from 'react';
import { api, setAuthToken } from '@/lib/api';

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [token, setToken] = useState(localStorage.getItem('ad_token'));
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const boot = async () => {
      const t = localStorage.getItem('ad_token');
      if (!t) { setLoading(false); return; }
      try {
        const { data } = await api.get('/auth/me');
        setUser(data);
        setToken(t);
      } catch (e) {
        setAuthToken(null);
        setToken(null);
      } finally {
        setLoading(false);
      }
    };
    boot();
  }, []);

  const login = async (email, password) => {
    const { data } = await api.post('/auth/login', { email, password });
    setAuthToken(data.access_token);
    setToken(data.access_token);
    setUser(data.user);
    return data.user;
  };

  const logout = async () => {
    try { await api.post('/auth/logout'); } catch {}
    setAuthToken(null);
    setToken(null);
    setUser(null);
  };

  const value = useMemo(() => ({ user, token, loading, login, logout, setUser }), [user, token, loading]);

  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
}

export const useAuth = () => useContext(AuthContext);

export const roleLabels = {
  super_admin: 'Platform Super Administrator',
  org_admin: 'Organisation Administrator',
  asset_manager: 'Asset Manager',
  analyst: 'Analyst',
  field_user: 'Field User',
  viewer: 'Management / Viewer',
};

export const canManageOrgs = (role) => role === 'super_admin';
export const canManageAssets = (role) => ['super_admin', 'org_admin'].includes(role);
export const canValidate = (role) => ['super_admin', 'org_admin', 'asset_manager', 'analyst'].includes(role);
export const isFieldUser = (role) => role === 'field_user';
